import { FhirBundleSdk } from "@metriport/fhir-sdk";
import { useMemo } from "react";
import { BaseTableLayout, ColumnDef } from "../../components/base-table-layout";
import { TableRow } from "../../utils/tables-metadata";
import { FamilyMemberHistoryRowData } from "./family-history-rows";

export type FamilyHistoryTableProps = {
  rows: TableRow[];
  onRowClick: (row: TableRow) => void;
  fhirSdk: FhirBundleSdk;
  filterQuery: string;
  onPdfView?: (docId: string) => void;
  displayName?: string;
};

export function FamilyHistoryTable({
  rows,
  onRowClick,
  filterQuery,
  displayName = "Family Member History",
}: FamilyHistoryTableProps) {
  function handleRowClick(row: TableRow) {
    onRowClick(row);
  }
  const columns: ColumnDef<FamilyMemberHistoryRowData>[] = useMemo(
    () => [
      { key: "familyMember", header: "Family Member" },
      { key: "sex", header: "Sex" },
      { key: "conditions", header: "Conditions" },
      { key: "deceased", header: "Deceased" },
    ],
    []
  );

  return (
    <BaseTableLayout
      title={displayName}
      rows={rows as unknown as FamilyMemberHistoryRowData[]}
      columns={columns}
      filterQuery={filterQuery}
      onRowClick={handleRowClick}
    />
  );
}
